// import { Link } from "react-router-dom";
// import PageBanner from "../../PageBanner";
// import SocialMediaSidebar from "../../SocialMediaSidebar";
// import SectionHeader from "../../SectionHeader";
// import digitalTrackingImage from "../../../assets/images/blog4digitalwaste.png"; // Add your image path
// import ScrollToTopButton from "../../ScrollToTopButton";

// const DigitalWasteTracking = () => {
//   return (
//     <>
//       <div>
//         <SocialMediaSidebar />
//       </div>
//       <PageBanner
//         title="Tracking Waste Digitally"
//         breadcrumb={[
//           { label: "Home", href: "/" },
//           { label: "Resources" },
//           { label: "Blogs" },
//         ]}
//       />
//       <div className="max-w-6xl mx-auto p-4">
//         <SectionHeader
//           title="Tracking Waste Digitally @ AJEEVI"
//           shareUrl="https://swmecom.ajeevi.in/blog/tracking-waste-digitally"
//         />
//       </div>
//       <div>
//         <ScrollToTopButton />
//       </div>

//       {/* Page content */}
//       <div className="w-full px-4 sm:px-6 md:px-10 lg:px-28 py-10 bg-white text-gray-800">
//         <div className="container mx-auto px-4 sm:px-6 lg:px-8">
//           {/* Summary Section with Image */}
//           <div className="flex flex-col lg:flex-row gap-8 mb-10">
//             <div className="lg:w-2/3">
//               <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
//                 Summary
//               </h4>
//               <p className="text-black mb-4 text-lg">
//                 Digital technologies are revolutionizing waste management by enabling real-time tracking of waste generation, movement, and disposal through RFID, GPS, and cloud-based systems.
//               </p>
//               <p className="text-black text-lg">
//                 These tools enhance transparency across the waste lifecycle, helping municipalities and waste companies improve accountability, streamline logistics, and achieve sustainability goals with greater operational efficiency.
//               </p>
//             </div>
//             <div className="lg:w-1/3">
//               <img 
//                 src={digitalTrackingImage} 
//                 alt="Digital waste tracking dashboard" 
//                 className="w-full h-auto rounded-lg shadow-lg object-cover"
//               />
//               <p className="text-sm text-gray-500 mt-2 italic">
//                 Real-time digital tracking of waste collection operations
//               </p>
//             </div>
//           </div>

//           {/* Introduction Section */}
//           <div className="mb-10">
//             <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
//               Introduction
//             </h4>
//             <div className="grid md:grid-cols-3 gap-6">
//               <div className="md:col-span-2">
//                 <p className="text-black mb-4 text-lg">
//                   In the era of smart cities, waste management systems are undergoing a digital revolution, replacing paper-based methods with IoT sensors, RFID technology, and cloud computing for end-to-end visibility.
//                 </p>
//                 <p className="text-black text-lg">
//                   These connected systems improve operational efficiency while enabling data-driven decisions for sustainable waste practices, from collection to processing and final disposal.
//                 </p>
//               </div>
//               <div className="bg-gray-50 p-4 rounded-lg border-l-4 border-[#00D084]">
//                 <h5 className="font-bold text-lg mb-2">Digital Tracking Impact</h5>
//                 <p className="text-gray-700">
//                   Cities using digital tracking report 30-40% reductions in collection costs and 50% fewer missed pickups.
//                 </p>
//               </div>
//             </div>
//           </div>

//           {/* Key Technologies Section */}
//           <div className="mb-10">
//             <h5 className="text-xl font-semibold mb-4 text-black">
//               Digital Tracking Technologies
//             </h5>
//             <div className="grid md:grid-cols-2 gap-6">
//               <div>
//                 <div className="bg-white p-4 rounded-lg shadow-sm mb-4 border-l-4 border-blue-500">
//                   <h6 className="font-semibold text-lg mb-2">RFID Tagging</h6>
//                   <p className="text-gray-700">
//                     Unique identification tags on bins enable precise tracking from source to disposal with scan rates up to 200 tags per second.
//                   </p>
//                 </div>
//                 <div className="bg-white p-4 rounded-lg shadow-sm mb-4 border-l-4 border-green-500">
//                   <h6 className="font-semibold text-lg mb-2">GPS Fleet Tracking</h6>
//                   <p className="text-gray-700">
//                     Real-time vehicle monitoring optimizes routes, reducing fuel use by 15-25% while improving service reliability.
//                   </p>
//                 </div>
//                 <div className="bg-white p-4 rounded-lg shadow-sm mb-4 border-l-4 border-purple-500">
//                   <h6 className="font-semibold text-lg mb-2">Cloud Platforms</h6>
//                   <p className="text-gray-700">
//                     Centralized dashboards aggregate data from multiple sources for comprehensive waste analytics and reporting.
//                   </p>
//                 </div>
//               </div>
//               <div>
//                 <div className="bg-white p-4 rounded-lg shadow-sm mb-4 border-l-4 border-red-500">
//                   <h6 className="font-semibold text-lg mb-2">Smart Bin Sensors</h6>
//                   <p className="text-gray-700">
//                     Fill-level sensors enable data-driven collection, reducing overflow complaints by up to 80%.
//                   </p>
//                 </div>
//                 <div className="bg-white p-4 rounded-lg shadow-sm mb-4 border-l-4 border-yellow-500">
//                   <h6 className="font-semibold text-lg mb-2">Blockchain</h6>
//                   <p className="text-gray-700">
//                     Immutable ledgers track waste transactions and recycling credits, enhancing supply chain transparency.
//                   </p>
//                 </div>
//                 <div className="bg-white p-4 rounded-lg shadow-sm mb-4 border-l-4 border-indigo-500">
//                   <h6 className="font-semibold text-lg mb-2">Mobile Apps</h6>
//                   <p className="text-gray-700">
//                     Field staff and citizens report issues and track collections in real-time through intuitive interfaces.
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Benefits Visual */}
//           <div className="mb-10 bg-gray-50 p-6 rounded-lg">
//             <h5 className="text-xl font-semibold mb-4 text-black text-center">
//               Operational Benefits
//             </h5>
//             <div className="grid md:grid-cols-3 gap-4">
//               <div className="bg-white p-4 rounded-lg shadow text-center">
//                 <div className="text-3xl font-bold text-[#00D084] mb-2">40%</div>
//                 <p className="text-gray-700">Reduction in collection costs</p>
//               </div>
//               <div className="bg-white p-4 rounded-lg shadow text-center">
//                 <div className="text-3xl font-bold text-[#00D084] mb-2">99%</div>
//                 <p className="text-gray-700">Tracking accuracy rate</p>
//               </div>
//               <div className="bg-white p-4 rounded-lg shadow text-center">
//                 <div className="text-3xl font-bold text-[#00D084] mb-2">50%</div>
//                 <p className="text-gray-700">Fewer service complaints</p>
//               </div>
//             </div>
//           </div>

//           {/* Conclusion Section */}
//           <div className="mb-10">
//             <h5 className="text-xl font-semibold mb-3 text-black">Conclusion</h5>
//             <div className="flex flex-col md:flex-row gap-6">
//               <div className="md:w-2/3">
//                 <p className="text-black text-lg">
//                   Digital tracking represents the future of efficient and sustainable waste management, enabling the transition from reactive to proactive operations. By reducing environmental impact and improving service quality, these technologies help build smarter, cleaner communities. When integrated with AI and advanced analytics, digital tracking systems gain predictive capabilities that further optimize waste management ecosystems.
//                 </p>
//               </div>
//               <div className="md:w-1/3 bg-[#00D084] bg-opacity-10 p-4 rounded-lg">
//                 <h6 className="font-semibold text-lg mb-2">Future Trends</h6>
//                 <p className="text-gray-700">
//                   Emerging technologies like computer vision and digital twins will enhance tracking precision and simulation capabilities.
//                 </p>
//               </div>
//             </div>
//           </div>

//           {/* Ajeevi's Contribution Section */}
//           <div className="bg-gray-50 p-6 rounded-lg">
//             <h5 className="text-xl font-semibold mb-3 text-black">
//               Ajeevi's Digital Tracking Solutions
//             </h5>
//             <div className="grid md:grid-cols-2 gap-6">
//               <div>
//                 <p className="text-black mb-4 text-lg">
//                   Ajeevi Technologies offers comprehensive digital tracking platforms tailored for modern waste management needs, combining hardware, software, and analytics for complete operational visibility.
//                 </p>
//                 <p className="text-black text-lg">
//                   Discover how Ajeevi can transform your waste operations at{" "}
//                   <a
//                     href="http://www.ajeevi.com"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                     className="text-[#00D084] hover:underline"
//                   >
//                     www.ajeevi.com
//                   </a>.
//                 </p>
//               </div>
//               <div>
//                 <ul className="list-disc pl-6 space-y-2 text-lg text-black">
//                   <li>
//                     <strong>End-to-End Platform:</strong> Integrated tracking from bins to processing facilities
//                   </li>
//                   <li>
//                     <strong>Custom RFID Solutions:</strong> Durable tags designed for waste environments
//                   </li>
//                   <li>
//                     <strong>Real-Time Analytics:</strong> Customizable dashboards with actionable insights
//                   </li>
//                   <li>
//                     <strong>Compliance Tools:</strong> Automated reporting for regulations
//                   </li>
//                 </ul>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };

// export default DigitalWasteTracking;

import { Link } from "react-router-dom";
import PageBanner from "../../PageBanner";
import SocialMediaSidebar from "../../SocialMediaSidebar";
import SectionHeader from "../../SectionHeader";
import digitalTrackingImage from "../../../assets/images/CentralizedManagement.png"; // Add your image path
import ScrollToTopButton from "../../ScrollToTopButton";

const DigitalWasteTracking = () => {
  return (
    <>
      <div>
        <SocialMediaSidebar />
      </div>
      <PageBanner
        title="Centralized Management of Smart Pole Networks"
        breadcrumb={[
          { label: "Home", href: "/" },
          { label: "Resources" },
          { label: "Blogs" },
        ]}
      />
      <div className="max-w-6xl mx-auto p-4">
        <SectionHeader
          title="Centralized Management of Smart Pole Networks @ AJEEVI"
          shareUrl="https://swmecom.ajeevi.in/blog/tracking-waste-digitally"
        />
      </div>
      <div>
        <ScrollToTopButton />
      </div>

      {/* Page content */}
      <div className="w-full px-4 sm:px-6 md:px-10 lg:px-28 py-10 bg-white text-gray-800">
  <div className="container mx-auto px-4 sm:px-6 lg:px-8">
    {/* Summary Section with Image */}
    <div className="flex flex-col lg:flex-row gap-8 mb-10">
      <div className="lg:w-2/3">
        <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
          Summary
        </h4>
        <p className="text-black mb-4 text-lg">
          Centralized management systems revolutionize smart pole networks by enabling unified control of lighting, sensors, and connected devices through cloud-based platforms. These solutions provide real-time monitoring and automated adjustments across entire smart pole deployments.
        </p>
        <p className="text-black text-lg">
          Municipalities and infrastructure operators implementing centralized management achieve higher energy efficiency, reduced maintenance costs, and enhanced public services through intelligent pole network optimization.
        </p>
      </div>
      <div className="lg:w-1/3">
        <img 
          src={digitalTrackingImage} 
          alt="Smart pole network management dashboard" 
          className="w-full h-auto rounded-lg shadow-lg object-cover"
        />
        <p className="text-sm text-gray-500 mt-2 italic">
          Centralized control interface for smart pole networks
        </p>
      </div>
    </div>

    {/* Introduction Section */}
    <div className="mb-10">
      <h4 className="text-[#00D084] text-2xl font-semibold mb-3">
        Introduction
      </h4>
      <div className="grid md:grid-cols-3 gap-6">
        <div className="md:col-span-2">
          <p className="text-black mb-4 text-lg">
            As cities deploy thousands of smart poles with diverse functions, centralized management becomes essential for coordinating lighting, environmental sensors, cameras, and communication devices across the urban landscape.
          </p>
          <p className="text-black text-lg">
            These unified control systems enable cities to transform street infrastructure from isolated assets into intelligent, responsive networks that adapt to real-time conditions and urban needs.
          </p>
        </div>
        <div className="bg-gray-50 p-4 rounded-lg border-l-4 border-[#00D084]">
          <h5 className="font-bold text-lg mb-2">Management Impact</h5>
          <p className="text-gray-700">
            Cities using centralized systems report 30-50% energy savings and 40% faster incident response through smart pole networks.
          </p>
        </div>
      </div>
    </div>

    {/* Key Technologies Section */}
    <div className="mb-10">
      <h5 className="text-xl font-semibold mb-4 text-black">
        Centralized Management Technologies
      </h5>
      <div className="grid md:grid-cols-2 gap-6">
        <div>
          <div className="bg-white p-4 rounded-lg shadow-sm mb-4 border-l-4 border-blue-500">
            <h6 className="font-semibold text-lg mb-2">Cloud Control Platform</h6>
            <p className="text-gray-700">
              Unified dashboard for monitoring and controlling all smart pole assets across the city with role-based access.
            </p>
          </div>
          <div className="bg-white p-4 rounded-lg shadow-sm mb-4 border-l-4 border-green-500">
            <h6 className="font-semibold text-lg mb-2">Dynamic Lighting Control</h6>
            <p className="text-gray-700">
              Adaptive brightness adjustment based on traffic, weather and schedules, reducing energy use by 30-60%.
            </p>
          </div>
          <div className="bg-white p-4 rounded-lg shadow-sm mb-4 border-l-4 border-purple-500">
            <h6 className="font-semibold text-lg mb-2">Predictive Maintenance</h6>
            <p className="text-gray-700">
              AI analyzes pole health data to schedule maintenance before failures occur.
            </p>
          </div>
        </div>
        <div>
          <div className="bg-white p-4 rounded-lg shadow-sm mb-4 border-l-4 border-red-500">
            <h6 className="font-semibold text-lg mb-2">Network Integration</h6>
            <p className="text-gray-700">
              Seamless connectivity between poles, city systems and IoT devices using multiple protocols.
            </p>
          </div>
          <div className="bg-white p-4 rounded-lg shadow-sm mb-4 border-l-4 border-yellow-500">
            <h6 className="font-semibold text-lg mb-2">Security Management</h6>
            <p className="text-gray-700">
              Centralized cybersecurity for all connected pole devices and data streams.
            </p>
          </div>
          <div className="bg-white p-4 rounded-lg shadow-sm mb-4 border-l-4 border-indigo-500">
            <h6 className="font-semibold text-lg mb-2">API Ecosystem</h6>
            <p className="text-gray-700">
              Integration with third-party applications for expanded smart city services.
            </p>
          </div>
        </div>
      </div>
    </div>

    {/* Benefits Visual */}
    <div className="mb-10 bg-gray-50 p-6 rounded-lg">
      <h5 className="text-xl font-semibold mb-4 text-black text-center">
        Operational Benefits
      </h5>
      <div className="grid md:grid-cols-3 gap-4">
        <div className="bg-white p-4 rounded-lg shadow text-center">
          <div className="text-3xl font-bold text-[#00D084] mb-2">45%</div>
          <p className="text-gray-700">Energy savings through smart lighting</p>
        </div>
        <div className="bg-white p-4 rounded-lg shadow text-center">
          <div className="text-3xl font-bold text-[#00D084] mb-2">90%</div>
          <p className="text-gray-700">Faster fault detection</p>
        </div>
        <div className="bg-white p-4 rounded-lg shadow text-center">
          <div className="text-3xl font-bold text-[#00D084] mb-2">60%</div>
          <p className="text-gray-700">Reduced maintenance costs</p>
        </div>
      </div>
    </div>

    {/* Conclusion Section */}
    <div className="mb-10">
      <h5 className="text-xl font-semibold mb-3 text-black">Conclusion</h5>
      <div className="flex flex-col md:flex-row gap-6">
        <div className="md:w-2/3">
          <p className="text-black text-lg">
            Centralized management transforms smart pole networks from passive infrastructure into dynamic urban assets that improve city services, public safety, and sustainability. As poles incorporate more sensors and capabilities, unified control systems become the critical platform for maximizing their value across municipal operations. Future integration with 5G, edge computing, and urban digital twins will further enhance smart pole network capabilities.
          </p>
        </div>
        <div className="md:w-1/3 bg-[#00D084] bg-opacity-10 p-4 rounded-lg">
          <h6 className="font-semibold text-lg mb-2">Future Trends</h6>
          <p className="text-gray-700">
            Edge AI and distributed computing will enable faster local decision-making across pole networks while maintaining central oversight.
          </p>
        </div>
      </div>
    </div>

    {/* Ajeevi's Contribution Section */}
    <div className="bg-gray-50 p-6 rounded-lg">
      <h5 className="text-xl font-semibold mb-3 text-black">
        Ajeevi's Smart Pole Management Solutions
      </h5>
      <div className="grid md:grid-cols-2 gap-6">
        <div>
          <p className="text-black mb-4 text-lg">
            Ajeevi Technologies offers comprehensive centralized management platforms for smart pole networks, combining hardware integration, cloud software, and advanced analytics for complete network visibility and control.
          </p>
          <p className="text-black text-lg">
            Discover how Ajeevi can optimize your smart pole infrastructure at{" "}
            <a
              href="http://www.ajeevi.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-[#00D084] hover:underline"
            >
              www.ajeevi.com
            </a>.
          </p>
        </div>
        <div>
          <ul className="list-disc pl-6 space-y-2 text-lg text-black">
            <li>
              <strong>Unified Control Center:</strong> Manage all pole assets from single interface
            </li>
            <li>
              <strong>Multi-Vendor Integration:</strong> Compatible with leading smart pole components
            </li>
            <li>
              <strong>Energy Optimization:</strong> AI-driven lighting and power management
            </li>
            <li>
              <strong>Scalable Architecture:</strong> Grow from pilot to city-wide deployment
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</div>
    </>
  );
};

export default DigitalWasteTracking;